import React, { useState, useRef, useEffect } from "react";
import { any, string, bool } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import LoadMore from "../../../atoms/loadmore";
import translate from "../../../translate";

import "./read-full-article.m.css";

const ReadFullArticle = ({ children, publisherName, readFullArticle }) => {
  const [readMore, setReadMore] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const elementHeight = ref.current.clientHeight;
    if (elementHeight > 650 && readFullArticle) {
      setReadMore(true);
    }
  }, []);

  const handleReadMore = () =>
    setReadMore(() => {
      window.history.replaceState(null, null, location.href + "#read-more");
      return false;
    });

  return (
    <>
      <div id="story-body-wrapper" styleName={`wrapper ${readMore ? "hide-content" : ""}`} ref={ref}>
        {children}
      </div>
      {readMore && (
        <div styleName="read-more">
          <LoadMore
            onClick={handleReadMore}
            content={translate(publisherName, "read_full_artcile")}
            id="read-full-article"
          />
        </div>
      )}
    </>
  );
};

ReadFullArticle.propTypes = {
  children: any,
  publisherName: string,
  readFullArticle: bool,
};

const mapStateToProps = (state) => ({
  publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  readFullArticle: get(state, ["qt", "config", "publisher-attributes", "read_full_article"], null),
});

export default connect(mapStateToProps, null)(ReadFullArticle);
